import { DAY_OF_WEEK } from "./Constants"

namespace OptionConst {

  export const NO_LABEL = [
    {
      label: '',
      val: true,
      code: ''
    }
  ]

  export const BLANK_OPTION = {
    label: '',
    val: null,
    code: ''
  }

  export const BLANK_CHILD_OPTION = {
    label: '',
    val: null,
    code: '',
    parent_id: null
  }

  export const ETC = '99'

  // 申請区分
  export const SHINSEI_DIV = {
    FULL_DAY: 1, // 1日
    AM: 2, // AM休
    PM: 3, // PM休
  }

  export const SHINSEI_DIV_OPTION = [
    { val: SHINSEI_DIV.FULL_DAY, label: "1日" },
    { val: SHINSEI_DIV.AM, label: "AM休" },
    { val: SHINSEI_DIV.PM, label: "PM休" },
  ];

  export const SHINSEI_DIV_FURIDE_OPTION = [
    { val: SHINSEI_DIV.FULL_DAY, label: "1日振出" },
    { val: SHINSEI_DIV.AM, label: "AM振出" },
    { val: SHINSEI_DIV.PM, label: "PM振出" },
  ];

  // 承認ステータス
  // ※ここに追加したらPHPのShinseiConst.phpにも同内容を追加すること
  export const SYOUNIN_STATUS = {
    WAIT: 1, // 承認待ち
    APPROVED: 2, // 承認済み
    DENIED: 3, // 否認済み
    REMAND: 4, // 差し戻し済み
    CANCEL: 9 // 取り下げ
  }

  // 申請全般用のステータス
  // ※ここに追加したらPHPのShinseiConst.phpにも同内容を追加すること
  export const SYOUNIN_STATUS_OPTION = [
    { val: SYOUNIN_STATUS.WAIT, label: '承認待ち' },
    { val: SYOUNIN_STATUS.APPROVED, label: '承認済み' },
    { val: SYOUNIN_STATUS.DENIED, label: '否認済み' },
    { val: SYOUNIN_STATUS.REMAND, label: '差し戻し済み' },
    { val: SYOUNIN_STATUS.CANCEL, label: '申請取消' }
  ];

  // 承認ステータス
  // ※ここに追加したらPHPのShinseiConst.phpにも同内容を追加すること
  export const DAKOKU_SYOUNIN_STATUS = {
    WAIT: 1, // 承認待ち
    APPROVED: 2, // 承認済み
    DENIED: 3, // 否認済み
  }

  // 打刻承認用のステータス
  // ※ここに追加したらPHPのShinseiConst.phpにも同内容を追加すること
  export const DAKOKU_SYOUNIN_STATUS_OPTION = [
    { val: DAKOKU_SYOUNIN_STATUS.WAIT, label: '承認待ち' },
    { val: DAKOKU_SYOUNIN_STATUS.APPROVED, label: '承認済み' },
    { val: DAKOKU_SYOUNIN_STATUS.DENIED, label: '否認済み' }
  ];


  /** 申請種別 */
  // ※ここに追加したらPHPのKoyouKeiyakuConst.phpにも同内容を追加すること
  export const KOYOU_SHINSEI_TYPE = {
    ENTRY:  1,
    UPDATE: 2,
    CHANGE: 3,
    REPLACE_ENTRY: 4,
    REPLACE: 5,
    ADD: 6
  }
  // ※ここに追加したらPHPのKoyouKeiyakuConst.phpにも同内容を追加すること
  export const KOYOU_SHINSEI_TYPE_OPTION = [
    { val: KOYOU_SHINSEI_TYPE.ENTRY, label: "入社" },
    { val: KOYOU_SHINSEI_TYPE.UPDATE, label: "更新" },
    { val: KOYOU_SHINSEI_TYPE.CHANGE, label: "内容変更" },
    { val: KOYOU_SHINSEI_TYPE.REPLACE_ENTRY, label: "入替（入社）" },
    { val: KOYOU_SHINSEI_TYPE.REPLACE, label: "入替（既存社員）" },
    { val: KOYOU_SHINSEI_TYPE.ADD, label: "追加" },
  ];

  // 雇用種別
  // ※ここに追加したらPHPのKoyouKeiyakuConst.phpにも同内容を追加すること
  export const KOYOU_TYPE = {
    GEKKYUU: 1,
    GEKKYUU_MUKI: 2,
    JIKYUU: 3,
    PART: 4,
    PART_MUKI: 5
  }
  // ※ここに追加したらPHPのKoyouKeiyakuConst.phpにも同内容を追加すること
  export const KOYOU_TYPE_OPTION = [
    { val: KOYOU_TYPE.GEKKYUU, label: "月給有期" },
    { val: KOYOU_TYPE.GEKKYUU_MUKI, label: "月給無期" },
    { val: KOYOU_TYPE.JIKYUU, label: "時給フルタイム" },
    { val: KOYOU_TYPE.PART, label: "パート有期" },
    { val: KOYOU_TYPE.PART_MUKI, label: "パート無期" }
  ]
  export const KOYOU_KEIYAKU_MUKI_LABEL = '（期間の定めなし）'

  /** 雇用形態種別 */
  // ※ここに追加したらPHPのKoyouKeiyakuConst.phpにも同内容を追加すること
  export const KOYOU_KEITAI_TYPE = {
    SEISYAIN: 1,
    KEIYAKUSYAIN_FULLTIME: 2,
    KEIYAKUSYAIN_PART: 3,
    HAKENSYAIN_FULLTIME: 4,
    HAKENSYAIN_PART: 5
  }
  // ※ここに追加したらPHPのKoyouKeiyakuConst.phpにも同内容を追加すること
  export const KOYOU_KEITAI_TYPE_OPTION = [
    { val: KOYOU_KEITAI_TYPE.SEISYAIN, label: "正社員" },
    { val: KOYOU_KEITAI_TYPE.KEIYAKUSYAIN_FULLTIME, label: "契約社員（フルタイム）" },
    { val: KOYOU_KEITAI_TYPE.KEIYAKUSYAIN_PART, label: "契約社員（パート）" },
    { val: KOYOU_KEITAI_TYPE.HAKENSYAIN_FULLTIME, label: "派遣社員（フルタイム）" },
    { val: KOYOU_KEITAI_TYPE.HAKENSYAIN_PART, label: "派遣社員（パート）" }
  ]

  /**
   * 申請種別（原則、下記名称の複数形のテーブルが存在する）
   * ※ここに追加したらPHPのShinseiConst.phpにも同内容を追加すること
   */
  export const SHINSEI_TYPE = {
    JIKANGAI: 'jikangai',
    FURIKYU: 'furikyuu',
    YUUKYUU: 'yuukyuu',
    KEKKIN: 'kekkin',
    SOUTAI: 'soutai',
    CHIKOKU: 'chikoku',
    KIBIKI: 'kibiki',
    IDOU: 'idou',
    KOSYOKU: 'kosyoku',
    NITTYOKU: 'nittyoku',
    KIKEN: 'kiken',
    SONOTA_TEATE: 'sonotateate',
    DAKOKU_SYUUSEI: 'dakoku_syuusei',
    KYUUKEI_JIKANGAI: 'kyuukei_jikangai',
  }

  // ここの値を変更する場合は以下も変更すること
  // src/resources/ts/components/shinsei/detail/FormNoApproval.vue内componentsの左側
  export const SHINSEI_TYPE_NO_APPROVAL = {
    HAYABAN_OSOBAN: 'hayaban_osoban',
    KOUKYUU: 'koukyuu',
  }

  export const SHINSEI_CODE = {
    JIKANGAI: 1,
    FURIKYUU: 2,
    YUUKYUU: 3,
    KEKKIN: 4,
    SOUTAI: 5,
    CHIKOKU: 6,
    KIBIKI: 7,
    IDOU: 8,
    KOSYOKU: 9,
    NITTYOKU: 10,
    KIKEN: 11,
    SONOTA_TEATE: 12,
    DAKOKU_SYUUSEI: 13,
    KYUUKEI_JIKANGAI: 14,
  }

  // 承認不要の申請に対するコード
  // ※ これらはGUI上は申請のように振る舞っているが全くが別の仕組みのため
  // 　 申請のように振る舞わせるためにここで擬似的にコードを設定している
  export const SHINSEI_CODE_NO_APPROVAL = {
    HAYABAN_OSOBAN: -1,
    KOUKYUU: -2,
  }

  export const SHINSEI_CODE_TYPE = [
    { code: SHINSEI_CODE.JIKANGAI, type: SHINSEI_TYPE.JIKANGAI },
    { code: SHINSEI_CODE.FURIKYUU, type: SHINSEI_TYPE.FURIKYU },
    { code: SHINSEI_CODE.CHIKOKU, type: SHINSEI_TYPE.CHIKOKU },
    { code: SHINSEI_CODE.YUUKYUU, type: SHINSEI_TYPE.YUUKYUU },
    { code: SHINSEI_CODE.KEKKIN, type: SHINSEI_TYPE.KEKKIN },
    { code: SHINSEI_CODE.SOUTAI, type: SHINSEI_TYPE.SOUTAI },
    { code: SHINSEI_CODE.KIBIKI, type: SHINSEI_TYPE.KIBIKI },
    { code: SHINSEI_CODE.IDOU, type: SHINSEI_TYPE.IDOU },
    // { code: SHINSEI_CODE.KOSYOKU, type: SHINSEI_TYPE.KOSYOKU },
    { code: SHINSEI_CODE.NITTYOKU, type: SHINSEI_TYPE.NITTYOKU },
    // { code: SHINSEI_CODE.KIKEN, type: SHINSEI_TYPE.KIKEN },
    // { code: SHINSEI_CODE.SONOTA_TEATE, type: SHINSEI_TYPE.SONOTA_TEATE },
    { code: SHINSEI_CODE.DAKOKU_SYUUSEI, type: SHINSEI_TYPE.DAKOKU_SYUUSEI },
    { code: SHINSEI_CODE.KYUUKEI_JIKANGAI, type: SHINSEI_TYPE.KYUUKEI_JIKANGAI }
  ]

  export const SHINSEI_CODE_TYPE_NO_APPROVAL = SHINSEI_CODE_TYPE.concat([
    { code: SHINSEI_CODE_NO_APPROVAL.HAYABAN_OSOBAN, type: SHINSEI_TYPE_NO_APPROVAL.HAYABAN_OSOBAN },
    { code: SHINSEI_CODE_NO_APPROVAL.KOUKYUU, type: SHINSEI_TYPE_NO_APPROVAL.KOUKYUU }
  ])

  export const SHINSEI_OPTION = [
    { val: SHINSEI_CODE.JIKANGAI, label: "時間外" },
    { val: SHINSEI_CODE.FURIKYUU, label: "振休・振出" },
    { val: SHINSEI_CODE.YUUKYUU, label: "有給休暇" },
    { val: SHINSEI_CODE.KEKKIN, label: "欠勤" },
    { val: SHINSEI_CODE.CHIKOKU, label: "遅刻" },
    { val: SHINSEI_CODE.SOUTAI, label: "早退" },
    { val: SHINSEI_CODE.KIBIKI, label: "忌引き届" },
    { val: SHINSEI_CODE.IDOU, label: "異動届" },
    // { val: SHINSEI_CODE.KOSYOKU, label: "個食手当" },
    { val: SHINSEI_CODE.NITTYOKU, label: "日直" },
    // { val: SHINSEI_CODE.KIKEN, label: "危険手当" },
    // { val: SHINSEI_CODE.SONOTA_TEATE, label: "その他手当" },
    { val: SHINSEI_CODE.DAKOKU_SYUUSEI, label: "打刻修正" },
    { val: SHINSEI_CODE.KYUUKEI_JIKANGAI, label: "休憩未取得" }
  ]

  export const SHINSEI_OPTION_WITH_NO_APPROVAL = SHINSEI_OPTION.concat([
    { val: SHINSEI_CODE_NO_APPROVAL.HAYABAN_OSOBAN, label: "早番・遅番" },
    { val: SHINSEI_CODE_NO_APPROVAL.KOUKYUU, label: "公休" },
  ])

  // Dateで使用する際はvalの値-1が月番号になるので注意
  export const MONTH = [
    { val: 1, label: "1月" },
    { val: 2, label: "2月" },
    { val: 3, label: "3月" },
    { val: 4, label: "4月" },
    { val: 5, label: "5月" },
    { val: 6, label: "6月" },
    { val: 7, label: "7月" },
    { val: 8, label: "8月" },
    { val: 9, label: "9月" },
    { val: 10, label: "10月" },
    { val: 11, label: "11月" },
    { val: 12, label: "12月" },
  ]

  // 承認フロータイプ
  export const SYOUNIN_FLOW_TYPES = {
    JIKANGAI: 1,
    FURIKYUU: 2,
    CHIKOKU: 3,
    SOUTAI: 4,
    KEKKIN: 5,
    YUUKYUU: 6,
    KIBIKI: 7,
    IDOU: 8,
    KIKEN: 9,
    NITTYOKU: 10,
    KOSYOKU: 11,
    SONOTA: 12,
    KYUUKEI_JIKANGAI: 13,
    KOYOUKEIYAKU: 21,
    DAKOKU_SYOUNIN: 31,
    DAKOKU_SYUUSEI: 32,
    DEFAULT: 99,
  }

  export const SYOUNIN_FLOW_TYPES_OPTION = [
    { val: SYOUNIN_FLOW_TYPES.JIKANGAI, label: '時間外' },
    { val: SYOUNIN_FLOW_TYPES.FURIKYUU, label: '振休・振出' },
    { val: SYOUNIN_FLOW_TYPES.CHIKOKU, label: '遅刻' },
    { val: SYOUNIN_FLOW_TYPES.SOUTAI, label: '早退' },
    { val: SYOUNIN_FLOW_TYPES.KEKKIN, label: '欠勤' },
    { val: SYOUNIN_FLOW_TYPES.YUUKYUU, label: '有給休暇' },
    { val: SYOUNIN_FLOW_TYPES.KIBIKI, label: '忌引き届' },
    { val: SYOUNIN_FLOW_TYPES.IDOU, label: '異動届' },
    // { val: SYOUNIN_FLOW_TYPES.KIKEN, label: '危険手当' },
    { val: SYOUNIN_FLOW_TYPES.NITTYOKU, label: '日直' },
    // { val: SYOUNIN_FLOW_TYPES.KOSYOKU, label: '個食手当' },
    // { val: SYOUNIN_FLOW_TYPES.SONOTA, label: 'その他手当' },
    { val: SYOUNIN_FLOW_TYPES.KYUUKEI_JIKANGAI, label: '休憩未取得' },
    { val: SYOUNIN_FLOW_TYPES.KOYOUKEIYAKU, label: '雇用契約' },
    { val: SYOUNIN_FLOW_TYPES.DAKOKU_SYUUSEI, label: '打刻修正' },
    { val: SYOUNIN_FLOW_TYPES.DAKOKU_SYOUNIN, label: '打刻承認' },
  ];

  // 申請
  export const SHINSEI_CODE_FOR_FLOW_TYPES = [
    {code: SHINSEI_CODE.JIKANGAI, flow_type: SYOUNIN_FLOW_TYPES.JIKANGAI },
    {code: SHINSEI_CODE.FURIKYUU, flow_type: SYOUNIN_FLOW_TYPES.FURIKYUU },
    {code: SHINSEI_CODE.CHIKOKU, flow_type: SYOUNIN_FLOW_TYPES.CHIKOKU },
    {code: SHINSEI_CODE.SOUTAI, flow_type: SYOUNIN_FLOW_TYPES.SOUTAI },
    {code: SHINSEI_CODE.KEKKIN, flow_type: SYOUNIN_FLOW_TYPES.KEKKIN },
    {code: SHINSEI_CODE.YUUKYUU, flow_type: SYOUNIN_FLOW_TYPES.YUUKYUU },
    {code: SHINSEI_CODE.KIBIKI, flow_type: SYOUNIN_FLOW_TYPES.KIBIKI },
    {code: SHINSEI_CODE.IDOU, flow_type: SYOUNIN_FLOW_TYPES.IDOU },
    {code: SHINSEI_CODE.KIKEN, flow_type: SYOUNIN_FLOW_TYPES.KIKEN },
    {code: SHINSEI_CODE.NITTYOKU, flow_type: SYOUNIN_FLOW_TYPES.NITTYOKU },
    {code: SHINSEI_CODE.KOSYOKU, flow_type: SYOUNIN_FLOW_TYPES.KOSYOKU },
    {code: SHINSEI_CODE.SONOTA_TEATE, flow_type: SYOUNIN_FLOW_TYPES.SONOTA },
    {code: SHINSEI_CODE.DAKOKU_SYUUSEI, flow_type: SYOUNIN_FLOW_TYPES.DAKOKU_SYUUSEI },
    {code: SHINSEI_CODE.KYUUKEI_JIKANGAI, flow_type: SYOUNIN_FLOW_TYPES.KYUUKEI_JIKANGAI },
  ]

  // 手当種別
  export const TEATE_TYPE = {
    KOYOUKEIYAKU: 1,
    SONOTA_TEATE: 2,
  }

  // お知らせ種別
  export const OSHIRASE_TYPE = {
    SHINSEI: 1,
    DAKOKU: 2,
    SHINSEI_APPROVED: 3,
    IDOU_APPROVED: 4,
    YUUKYUU_APPROVED: 5,
    SHINSEI_DENIED: 6,
    DAKOKU_DENIED: 7,
    HAKENSAKI_APPROVED: 8,
    HAKENSAKI_DENIED: 9,
    DAKOKU_SYOUNIN_NOTICE: 10,
    ZANGYOU_20_HOURS_OVER: 11,
    YUUKYUU_FUYO: 21,
    YUUKYUU_NOT_SYUTOKU: 22,
    KOYOU_KEIYAKU: 31,
    KOYOU_APPROVED: 32,
    KOYOU_CANCEL: 33,
    KOYOU_SELF_APPROVED: 34,
    KOYOU_DENIED: 35,
    KOYOU_DENIED_BY_PRESIDENT: 36,
    KOYOU_REVIEW: 37,
    KOYOU_REVIEW_BY_TRIAL: 38,
    SYAIN_TAISYOKU: 41,
    KAISYA_RENRAKU: 91,
  }

  // 会社連絡宛先種類
  export const KAISYA_RENRAKU_TARGET_TYPE = {
    TO_ALL: 1,
    TO_BUKA: 2,
    TO_KOJIN: 3
  };

  // 会社連絡宛先オプション
  export const KAISYA_RENRAKU_TARGET_TYPE_OPTION = [
    { 'val': KAISYA_RENRAKU_TARGET_TYPE.TO_ALL, 'label': '社員全員' },
    { 'val': KAISYA_RENRAKU_TARGET_TYPE.TO_BUKA, 'label': '部課' },
    { 'val': KAISYA_RENRAKU_TARGET_TYPE.TO_KOJIN, 'label': '個人' }
  ];

  // 届出区分
  export const TODOKEDE_KUBUN = {
    JUUSYO_CHANGE: 1,
    FUYOU_KAZOKU_IDOU: 2,
    KEKKON: 3,
    SYUSSEI: 4,
    SHIBOU: 5,
    KAISEI: 6,
    HANNICHI_HOSEI: 7,
  };

  // 届出区分オプション
  export const TODOKEDE_KUBUN_OPTION_PM = [
    { 'val': TODOKEDE_KUBUN.JUUSYO_CHANGE, 'label': '住所変更届' },
    { 'val': TODOKEDE_KUBUN.FUYOU_KAZOKU_IDOU, 'label': '扶養家族異動届' },
    { 'val': TODOKEDE_KUBUN.KEKKON, 'label': '結婚届' },
    { 'val': TODOKEDE_KUBUN.SYUSSEI, 'label': '出生届' },
    { 'val': TODOKEDE_KUBUN.SHIBOU, 'label': '死亡届' },
    { 'val': TODOKEDE_KUBUN.KAISEI, 'label': '改姓届' },
  ];
  export const TODOKEDE_KUBUN_OPTION_PG = [
    { 'val': TODOKEDE_KUBUN.JUUSYO_CHANGE, 'label': '住所変更届' },
    { 'val': TODOKEDE_KUBUN.FUYOU_KAZOKU_IDOU, 'label': '扶養家族異動届' },
    { 'val': TODOKEDE_KUBUN.KEKKON, 'label': '結婚届' },
    { 'val': TODOKEDE_KUBUN.SYUSSEI, 'label': '出生届' },
    { 'val': TODOKEDE_KUBUN.SHIBOU, 'label': '死亡届' },
    { 'val': TODOKEDE_KUBUN.KAISEI, 'label': '改姓届' },
    { 'val': TODOKEDE_KUBUN.HANNICHI_HOSEI, 'label': '半日補正' },
  ];

  // 所属会社
  export const SYOZOKU = {
    PM: 1,
    PG: 2,
  };

  // 曜日ラベル
  export const YOUBI_LABEL = {
    SUNDAY: DAY_OF_WEEK[0],
    MONDAY: DAY_OF_WEEK[1],
    TUESDAY: DAY_OF_WEEK[2],
    WEDNESDAY: DAY_OF_WEEK[3],
    THURSDAY: DAY_OF_WEEK[4],
    FRIDAY: DAY_OF_WEEK[5],
    SATURDAY: DAY_OF_WEEK[6],
  }

  export const DEFAULT_NOTES_VALUE = '無し'

  // 雇用契約.支払日
  // ※ここに追加したらPHPのKoyouKeiyakuConst.phpにも同内容を追加すること
  export const PAY_DAY = 15;
  export const SHIME_LAST_DAY = 31;


  /** 本人ステータスタイプ */
  // ※ここに追加したらPHPのKoyouKeiyakuConst.phpにも同内容を追加すること
  export const SELF_TYPE_UNNOTIFINED = 1;    // 本人未通知
  export const SELF_TYPE_NOTIFINED = 2;   // 本人通知済
  export const SELF_TYPE_APPROVED = 3;   // 本人了承済
  export const SELF_TYPE_DENIED = 4;   // 本人辞退
  export const SELF_APPROVAL_TYPE = [
    { val: SELF_TYPE_UNNOTIFINED, label: '未通知' },
    { val: SELF_TYPE_NOTIFINED, label: '通知済' },
    { val: SELF_TYPE_APPROVED, label: '了承済' },
    { val: SELF_TYPE_DENIED, label: '辞退' },
  ]

  export const KEIYAKU_SEARCH_TYPE = {
    FREE: 0, // 自由入力
    KOUSHIN: 1, // 契約期間終了1ヶ月前,
    NYUUSYA: 2, // 入社後1ヶ月
    SYANAI_SYOUNIN: 3, // 社内承認中
    HONNIN_SYOUNIN: 4, // 本人承認中,
    EDIT: 5, // 編集中一覧,
    MY_TASK: 6 // マイタスク一覧
  }

  /** 締め日 */
  export const SHIME_DAY_TYPE = {
    GETSUMATSU: 0,
    SHITEIBI: 1
  }

  export const SHIME_DAY_TYPE_OPTIONS = [
    { val: SHIME_DAY_TYPE.GETSUMATSU, label: '月末' },
    { val: SHIME_DAY_TYPE.SHITEIBI, label: '指定日' },
  ]

  export const KYUUJISU_SYUTOKU_TYPE = {
    ONE_DAY: 1,
    NOT_ONE_DAY: 0
  }

  export const KYUUJISU_SYUTOKU_TYPE_OPTIONS = [
    { val: KYUUJISU_SYUTOKU_TYPE.ONE_DAY, label: '半日勤務無しを選択した場合、１日有給として取り扱う' },
    { val: KYUUJISU_SYUTOKU_TYPE.NOT_ONE_DAY, label: '半日勤務無しを選択するが、1日有給として取り扱わない場合' },
  ]

  export const KINMU_TYPE = {
    AM_KINMU: 1,
    PM_KINMU: 2
  }
  export const KINMU_TYPE_OPTIONS = [
    { val: KINMU_TYPE.AM_KINMU, label: 'AM勤務でAM有給しか取得できない、指定した通常勤務時間がAM有給取得時間となる' },
    { val: KINMU_TYPE.PM_KINMU, label: 'PM勤務でPM有給しか取得できない、指定した通常勤務時間がPM有給取得時間となる' },
  ]

  export const KOYOUKEIYAKU_EDIT_MODE = {
    CREATE: 'create',
    EDIT: 'edit',
    FROM: 'from',
    MODIFY: 'modify',
  }

  // 届出区分
  export const WEEK_OF_NUM = [
    { val: 1, label: '第1' },
    { val: 2, label: '第2' },
    { val: 3, label: '第3' },
    { val: 4, label: '第4' },
    { val: 5, label: '第5' },
  ];

  export const SHINSEI_SYOUNIN_STATUS_OPTION = [
    { val: null, label: 'すべて' },
    { val: SYOUNIN_STATUS.WAIT, label: '承認待ち' },
    { val: SYOUNIN_STATUS.APPROVED, label: '承認済み' },
    { val: SYOUNIN_STATUS.DENIED, label: '否認済み' }
  ];

  // 会社連絡：検索種別
  export const RENRAKU_SERACH_TYPE = {
    RECEIVE: 1,
    SEND: 2,
    OTHER: 3
  };

  // export const RENRAKU_SERACH_TYPE_OPTION = [
  //   { val: RENRAKU_SERACH_TYPE.RECEIVE, label: '受信' },
  //   { val: RENRAKU_SERACH_TYPE.SEND, label: '送信' },
  //   { val: RENRAKU_SERACH_TYPE.OTHER, label: '他の人が作成した連絡事項' },
  // ];

  // 会社連絡：検索種別
  export const RENRAKU_SERACH_READ = {
    ALL: 0,
    READ: 1,
    UNREAD: 2
  };

  export const RENRAKU_SERACH_READ_OPTION = [
    { val: RENRAKU_SERACH_READ.ALL, label: 'すべて' },
    { val: RENRAKU_SERACH_READ.READ, label: '既読のみ' },
    { val: RENRAKU_SERACH_READ.UNREAD, label: '未読のみ' },
  ];

  // 会社連絡：検索種別
  export const RENRAKU_VIEW_TYPE = {
    RECEIVE: 'receive',
    SEND: 'send',
  }

  // 有給申請：取得区分の表示種別
  export const YUUKYUU_TYPE = {
    ALL: 'all',
    NO_HARF: 'noHarf',
    FIX_TIME: 'fixTime',
  }

  export const KAKUNIN_STATUS_OPTION = [
    { val: SYOUNIN_STATUS.WAIT, label: '確認待ち' },
    { val: SYOUNIN_STATUS.APPROVED, label: '確認済み' },
  ];
}

export default OptionConst
